import { Media } from '@eiq/files/models';

import { ChoiceTypeResult } from './choice-type-result.interface';

export class SurveyResult {
  [qId: string]: string | ChoiceTypeResult | Media[];
}
